<template>
    <div>
     <v-container fluid>
       <CitySelector
        @CITY="city"
        @restaurants="restaurants"
        @restaurants_selected="restaurants_selected"
        ></CitySelector>
      <v-row align="center">
        <v-col
            cols="8"
            sm="10"
        >
        <v-select
            :items="dateList"
            attach
            chips
            multiple
            label="Dates"
            v-model="date_list_selected"
            @change="fetchApiData()"
        ></v-select>
        </v-col>
        <v-col
            cols="2"
            sm="1"
          >
            <AddNewData
            v-bind:RESTAURANTS="RESTAURANTS"
            v-bind:CITY="CITY"
            v-bind:DATELIST="dateList"
        ></AddNewData>
          </v-col>
          <v-col
            cols="2"
            sm="1"
          >
            <v-btn
              icon
              color="green"
              large
              @click="fetchApiData"
            >
              <v-icon>mdi-cached</v-icon>
            </v-btn>
          </v-col>


      </v-row>
    </v-container>
    <v-data-table
        dense
        hide-default-footer
        disable-pagination
        :sort-by="['CITY_RESTAURANT', 'DATE']"
        :sort-desc="[false,false]"
        :headers="headers" 
        :items="FILTERED_FOODS"
        :mobile-breakpoint='100'
    >
      <!-- RESTAURANT-->
      <template v-slot:item.CITY_RESTAURANT="{ item }">
        <a :href=item.URL target="_blank">
          {{item.CITY_RESTAURANT}}
        </a>
      </template>
      
      <!-- DATE -->
      <template v-slot:item.DATE="{ item }">
          {{  dateAndWeekDay(item.DATE) }}
      </template>
      <!-- TYPE -->
      <template v-slot:item.TYPE="{ item }">
          {{  item.TYPE }}
      </template>
      
      <!-- POS -->
      <template v-slot:item.POS="props">
        <v-edit-dialog
          :return-value.sync="props.item.POS"
          large
          @save="save(props.item)"
          @cancel="cancel"
          @open="open"
          @close="close"
        >
          {{ props.item.POS }}
          <template v-slot:input>
            <v-text-field
              v-model="props.item.POS"
              label="Edit"
              :rules="[rules.is_number]"
              single-line
              counter
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>


      <!-- RUOKA 0 -->
      <template v-slot:item.Ruoka_0="props">
        <v-edit-dialog
          :return-value.sync="props.item.Ruoka_0"
          large
          @save="save(props.item)"
          @cancel="cancel"
          @open="open"
          @close="close"
        >
          {{ props.item.Ruoka_0 }}
          <template v-slot:input>
            <v-text-field
              v-model="props.item.Ruoka_0"
              :rules="[max80chars]"
              label="Edit"
              single-line
              counter
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>

      <!-- RUOKA 1 -->
      <template v-slot:item.Ruoka_1="props">
        <v-edit-dialog
          :return-value.sync="props.item.Ruoka_1"
          large
          @save="save(props.item)"
          @cancel="cancel"
          @open="open"
          @close="close"
        >
          {{ props.item.Ruoka_1 }}
          <template v-slot:input>
            <v-text-field
              v-model="props.item.Ruoka_1"
              :rules="[max80chars]"
              label="Edit"
              single-line
              counter
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>
      <!-- RUOKA 2 -->
      <template v-slot:item.Ruoka_2="props">
        <v-edit-dialog
          :return-value.sync="props.item.Ruoka_2"
          large
          @save="save(props.item)"
          @cancel="cancel"
          @open="open"
          @close="close"
        >
          {{ props.item.Ruoka_2 }}
          <template v-slot:input>
            <v-text-field
              v-model="props.item.Ruoka_2"
              :rules="[max80chars]"
              label="Edit"
              single-line
              counter
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>

      <!-- RUOKA 3 -->
      <template v-slot:item.Ruoka_3="props">
        <v-edit-dialog
          :return-value.sync="props.item.Ruoka_3"
          large
          @save="save(props.item)"
          @cancel="cancel"
          @open="open"
          @close="close"
        >
          {{ props.item.Ruoka_3 }}
          <template v-slot:input>
            <v-text-field
              v-model="props.item.Ruoka_3"
              :rules="[max80chars]"
              label="Edit"
              single-line
              counter
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>

      <!-- RUOKA 4 -->
      <template v-slot:item.Ruoka_4="props">
        <v-edit-dialog
          :return-value.sync="props.item.Ruoka_4"
          large
          @save="save(props.item)"
          @cancel="cancel"
          @open="open"
          @close="close"
        >
          {{ props.item.Ruoka_4 }}
          <template v-slot:input>
            <v-text-field
              v-model="props.item.Ruoka_4"
              :rules="[max80chars]"
              label="Edit"
              single-line
              counter
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>

      <!-- RUOKA 5 -->
      <template v-slot:item.Ruoka_5="props">
        <v-edit-dialog
          :return-value.sync="props.item.Ruoka_5"
          large
          @save="save(props.item)"
          @cancel="cancel"
          @open="open"
          @close="close"
        >
          {{ props.item.Ruoka_5 }}
          <template v-slot:input>
            <v-text-field
              v-model="props.item.Ruoka_5"
              :rules="[max80chars]"
              label="Edit"
              single-line
              counter
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>

      <!-- RUOKA 6 -->
      <template v-slot:item.Ruoka_6="props">
        <v-edit-dialog
          :return-value.sync="props.item.Ruoka_6"
          large
          @save="save(props.item)"
          @cancel="cancel"
          @open="open"
          @close="close"
        >
          {{ props.item.Ruoka_6 }}
          <template v-slot:input>
            <v-text-field
              v-model="props.item.Ruoka_6"
              :rules="[max80chars]"
              label="Edit"
              single-line
              counter
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-row justify="space-around">
        <AddDataManual
            @refresh-data="addItemsToFilterdFoods"
            @post-data="postApiData"
            v-bind:ITEM="item"
            v-bind:DATELIST="dateList"
        ></AddDataManual>
          
        </v-row>
      </template>

      <template v-slot:item.delete="{ item }">
        <v-row justify="space-around">
          <v-icon
            @click="deleteItem(item)"
            color="red darken-2"
          >
            mdi-delete
          </v-icon>
          <v-dialog v-model="dialogDelete" max-width="500px" :retain-focus="false">
            <v-card>
              <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
              <v-card-text>Restaurant: {{ITEM.CITY_RESTAURANT}}, DATE:{{ITEM.DATE}}</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

        </v-row>
      </template>

      
    </v-data-table>
  </div>
</template>


<script>
import CitySelector from "./citySelector";
import AddNewData from "./addNewData";
import AddDataManual from "./addDataManual"; 
import moment from 'moment-timezone';

export default {
    name: 'LunchTables',
    components: { CitySelector, AddNewData, AddDataManual },
    data() {
        return {
            dialogDelete: false,
            snack: false,
            snackColor: '',
            snackText: '',
            max80chars: v => v.length <= 80 || 'Input too long!',
           headers: [
                { text: 'Actions', value: 'actions', sortable: false },
                { text: 'TYPE', value: 'TYPE' },
                { text: 'POS', value: 'POS' },
                {
                    text: 'RESTAURANT',
                    align: 'start',
                    style: "bold",
                    value: 'CITY_RESTAURANT'
                },
                { text: 'DATE', value: 'DATE' },
                { text: 'Ruoka_0', value: 'Ruoka_0' },
                { text: 'Ruoka_1', value: 'Ruoka_1' },
                { text: 'Ruoka_2', value: 'Ruoka_2' },
                { text: 'Ruoka_3', value: 'Ruoka_3' },
                { text: 'Ruoka_4', value: 'Ruoka_4' },
                { text: 'Ruoka_5', value: 'Ruoka_5' },
                { text: 'Ruoka_6', value: 'Ruoka_6' },
                { text: 'Delete', value: 'delete', sortable: false },
            ],
            FOODS: [],
            FILTERED_FOODS: [],
            Month: '',
            Day: '',
            dateList: [],
            date_list_selected: [],
            dayList: [],
            CITY: '',
            RESTAURANTS: [],
            RESTAURANTS_SELECTED: [],
            ITEM: {},
            rules: {
              is_number: value => parseInt(value) <= 100 || 'Must be a number and less than 100.'
            }
        }
    },
    methods: {
        save (item) {
          console.log("SAVE:", item);
          this.postApiData(item);
          this.snack = true;
          this.snackColor = 'success';
          this.snackText = 'Data saved';
        },
        cancel () {
            this.snack = true;
            this.snackColor = 'error';
            this.snackText = 'Canceled';
        },
        open () {
            this.snack = true;
            this.snackColor = 'info';
            this.snackText = 'Dialog opened';
        },
        close () {
            console.log('Dialog closed');
        },
        city (value) {
          this.CITY = value;
        },
        restaurants (value) {
          this.RESTAURANTS = value;
        },
        restaurants_selected (value) {
          this.RESTAURANTS_SELECTED = value;
        },
        filterFoods () {
          // Only show restaurants that are selected by the user
          var foods = this.FOODS;
          var selected_restaurants = this.RESTAURANTS_SELECTED;
          console.log("foods", foods);
          console.log("selected_restaurants", selected_restaurants);
          
          this.FILTERED_FOODS = foods.filter(food => selected_restaurants.includes(food.CITY_RESTAURANT.split("_")[1]));
          console.log("FILTERED_FOODS:", this.FILTERED_FOODS);
        },
        addItemsToFilterdFoods(item) {
          console.log("CHANGE FILTERED ITEMS:", item);
          var i = this.FILTERED_FOODS.findIndex(
            element => element.CITY_RESTAURANT === item.CITY_RESTAURANT && element.DATE === item.DATE
          );
          console.log("ITEM FOUND AT", i);
          this.FILTERED_FOODS.splice(i, 1, item);
        },
        getDateStamp(i) {
          var date = moment.tz(moment().add(i,'days'), 'Europe/Helsinki').format('YYYY-MM-DD');
          return date; 
        },
        getDatesInWeek() {
            var dateList = [];
            var date;
            for (var i = 0; i < 90; i++) {
              date = this.getDateStamp(i);
              dateList.push(date);
            }
            this.dateList = dateList;
            return dateList;
        },
        fetchApiData() {
            var response, url;
            var datelist = this.date_list_selected;
            this.FOODS = [];
            this.FILTERED_FOODS = [];
            var city = this.CITY
            city = city.toLowerCase();
            for (var date in datelist) {
                url = this.$store.state.api_url + "food?city=" + city + "&date=" + datelist[date];
                console.log(url);
                fetch(url, {
                  "method": "GET",
                  "mode": "cors",
                  "headers": {
                    'Content-Type': 'application/json',
                    'Authorization': this.$store.state.token
                  }
                })
                .then(response => response.json()) 
                .then(data => { 
                    if(data){
                        console.log(data);
                        for (var i in data) {
                            this.FOODS.push(data[i]);
                        }
                        this.filterFoods();
                    } else{
                        alert("Server returned " + response.status + " : " + response.statusText);
                    }                
                })
                .catch(err => {
                    console.log(err);
                });

            }            

        },
        postApiData(item){
            var response, url;
            url = this.$store.state.api_url + "food";
            console.log(url);
            fetch(url, {
              "method": "POST",
              "mode": "cors",
              "headers": {
                'Content-Type': 'application/json',
                'Authorization': this.$store.state.token
              },
              "body": JSON.stringify(item)
            })
            .then(response => response.json()) 
            .then(data => { 
                if(data){
                    console.log(data);
                } else{
                    alert("Server returned " + response.status + " : " + response.statusText);
                }                
            })
            .catch(err => {
                console.log(err);
            });          
        },
        deleteFoodItem(city_restaurant, date) {
          console.log("Deleting item using API");
          var response, url;
          var c_r = city_restaurant.replace("&", "%26");
          url = this.$store.state.api_url + "food?city_restaurant=" + c_r + "&date=" + date;
          console.log(url);
          fetch(url, {
              "method": "DELETE",
              "mode": "cors",
              "headers": {
                  'Content-Type': 'application/json',
                  'Authorization': this.$store.state.token
              }
          })
          .then(response => response.json()) 
          .then(data => { 
              if(data){
                  console.log(data);
              } else{
                  alert("Server returned " + response.status + " : " + response.statusText);
              }                
          })
          .catch(err => {
              console.log(err);
          });
        },
        getWeekday(date) {
          // Date in YYYY-MM-DD
          // return number 0 = sunday, 1 = monday
          var d = moment(date);
          var wd = d.day();
          return wd;
        },
        dateAndWeekDay(date){
          var dw = "";
          var wd_list = ["Su", "Ma", "Ti", "Ke", "To", "Pe", "La"];
          var wd = this.getWeekday(date);
          dw = date + " " + wd_list[wd];
          return dw;
        },
        deleteItem (item) {
          console.log("ITEM:", item);
          this.ITEM = item;
          this.dialogDelete = true;
        },
        deleteItemConfirm () {
          var city_restaurant, date;
          city_restaurant = this.ITEM.CITY_RESTAURANT;
          date = this.ITEM.DATE;
          this.deleteFoodItem(city_restaurant, date);
          this.closeDelete();
          this.ITEM = "";
          this.fetchApiData();
        },
        closeDelete () {
          this.dialogDelete = false;
        }
    },
    mounted() {
        var datelist = this.getDatesInWeek();
        this.fetchApiData(datelist);
    },
    watch: {
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },
}
</script>



<style scoped>
p{
    font-size: 10px;
}
a {
    color: #0067a7 !important;
    text-decoration: none;
    font-size: 16px;
}
a:hover {
    color: #0c0c0c;
    text-decoration: underline;
}

.lunch-table-header {
    text-align: center;
    background-color: #e6e6e6;
}

thead {
    border-bottom-width: 2px;
    vertical-align: bottom;
    border-bottom: 2px solid #e9ecef;
    border: 1px solid #e9ecef;
    padding: 4px;
}

th {
    border-bottom-width: 2px;
    vertical-align: top;
    border-bottom: 2px solid #e9ecef;
    border: 1px solid #e9ecef;
    padding: 4px;
}


td {
    border: 1px solid #e9ecef;
    padding-left: 10px;
}


table {
    width: 100%;
    max-width: 100%;
    margin-bottom: 0.01rem;
    background-color: transparent;
    border-collapse: collapse;
    border: 1px solid #e9ecef;
    display: table;
    white-space: normal;
    line-height: normal;
    font-weight: normal;
    font-size: medium;
    font-style: normal;
    color: -internal-quirk-inherit;
    text-align: start;
    border-spacing: 2px;
    font-variant: normal;
}

.w-66 {
    width: 66% !important;
}
.w-33 {
    width: 33% !important;
}


</style>